let isSpeechEnabled = false

export function addSpeechListeners() {
  if (!('speechSynthesis' in window)) {
    console.error('Web Speech API не поддерживается в данном браузере.')
    return
  }

  document.addEventListener('mouseup', handleMouseUp)
  document.addEventListener('selectionchange', handleSelectionChange)
}

export function removeSpeechListeners() {
  document.removeEventListener('mouseup', handleMouseUp)
  document.removeEventListener('selectionchange', handleSelectionChange)
}

function handleMouseUp() {
  const selectedText = window.getSelection().toString().trim()

  if (selectedText && !isSpeechEnabled) {
    speakOnce(selectedText)
  }
}

function handleSelectionChange() {
  isSpeechEnabled = false
}

function speakOnce(text) {
  const synth = window.speechSynthesis
  const utterance = new SpeechSynthesisUtterance(text)

  utterance.onend = () => {
    isSpeechEnabled = true
  }

  synth.speak(utterance)
}
